import { NgOptimizedImage } from '@angular/common';
import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AiguillagePipe, ContextService } from '@bcef/ia-shared';
import { TranslateModule } from '@ngx-translate/core';
import { from } from 'rxjs';

@Component({
  selector: 'ia-parrainage-filleul-header',
  templateUrl: './header.component.html',
  imports: [TranslateModule, NgOptimizedImage],
  providers: [AiguillagePipe],
})
export class HeaderComponent {
  private readonly contextService = inject(ContextService);

  private readonly aiguillagePipe = inject(AiguillagePipe);

  protected readonly isHbGroup = this.contextService.isHbGroup;

  protected readonly logos: Record<string, { file: string; height: string; width: string }> = {
    part: {
      file: 'logo-mb',
      height: '70',
      width: '240',
    },
    pro: {
      file: 'logo-mb',
      height: '70',
      width: '240',
    },
    bpf: {
      file: 'logo-mb',
      height: '70',
      width: '240',
    },
    nhb: {
      file: 'logo-nhb',
      height: '70',
      width: '64',
    },
    nhbpro: {
      file: 'logo-nhbpro',
      height: '70',
      width: '64',
    },
  };

  protected readonly logo = this.logos[this.contextService.typology];

  public homePageUrl = toSignal(from(this.aiguillagePipe.transform('homePage')), {
    initialValue: '',
  });
}
